import {State} from "country-state-city";

export const getStateOptions = (countryCode = 'US') => {
    return (State.getStatesOfCountry(countryCode)).map(state => {
        return {
            name: state.name,
            value: state.isoCode
        }
    })
};